// extracted by mini-css-extract-plugin
export default {"modal__footer":"modal__footer_menNhca1","modal__height":"modal__height_kZU7Hro7"};